import { GatsbySSR } from 'gatsby';
import React from 'react';
import Layout from './components/layouts/Layout';

const wrapPageElement: GatsbySSR['wrapPageElement'] = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
);

export default wrapPageElement;
